import { BasicBotData, BotData } from "@shared/types";
import DisconnectOutlined from "@ant-design/icons/DisconnectOutlined";
import StatusTag from "common/Tags/StatusTag";
import InactiveAccountIcon from "features/configuration/common/InactiveAccountIcon";
import { useBotStatusTag } from "@shared/features/bots/hooks";
import { AccountObjectType } from "@shared/features/settings/types";
import React, { CSSProperties } from "react";

interface BotStatusProps {
  bot: BotData | BasicBotData;
  hideText?: boolean;
  isTable?: boolean;
  hideBgColor?: boolean;
  /** Extra styles for the tag (merged over the defaults). */
  style?: CSSProperties;
}

const BotStatusTag = ({
  bot,
  hideText,
  isTable,
  hideBgColor,
  style,
}: BotStatusProps) => {
  const { color, invalidAccountData, isBotActive, isBotArchived } =
    useBotStatusTag(bot);

  const statusIcon = invalidAccountData.isInvalidOrInactive ? (
    <DisconnectOutlined
      style={{ color, marginRight: hideText ? 0 : 6, fontSize: 14 }}
    />
  ) : undefined;

  const statusTag = (
    <StatusTag
      style={{
        marginLeft: 8,
        height: 23,
        padding: hideText ? 6 : undefined,
        ...style,
      }}
      isActive={isBotActive}
      isArchived={isBotArchived}
      size={isTable ? undefined : "small"}
      showText={!hideText}
      withBgColor={!hideBgColor}
      statusIcon={statusIcon}
      color={color}
    />
  );

  return (
    <InactiveAccountIcon
      objectType={AccountObjectType.BOT}
      accountId={bot.client_id}
      invalidColor={color}
      hideIcon={true}
    >
      {statusTag}
    </InactiveAccountIcon>
  );
};

export default React.memo(BotStatusTag);
